<template>
  <el-dropdown @command="handle"
               style="cursor: pointer;">
    <span class="el-dropdown-link">
      {{$t('Language')}}<i class="el-icon-caret-bottom el-icon--right"></i>
    </span>
    <el-dropdown-menu v-slot="dropdown">
      <el-dropdown-item v-for="(item, index) of list"
                        :key="index"
                        :disabled="$t('Language') == item.name"
                        :command="item.key">{{item.name}}</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  name: 'change-language',
  data() {
    return {
      list: [
        { key: 'en', name: 'English' }, // 英语
        { key: 'es', name: 'Español' }, // 西班牙语
        { key: 'zh-CN', name: '简体中文' }, // 简体中文
        { key: 'zh-TW', name: '繁體中文' }, // 繁体中文
      ],
    }
  },
  methods: {
    handle(value) {
      this.$i18n.locale = value
      localStorage.setItem('change-language', value)
      location.reload()
    },
  },
}
</script>
<style scoped lang="scss">
</style>
